/**
 * Explanner Service Documentation
 * Explanner Service Documentation
 *
 * The version of the OpenAPI document: 1.7_landesstelle{20240611@153537}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateDataRequest { 
  [key: string]: object | any;


    docId?: string;
    dataType?: UpdateDataRequest.DataTypeEnum;
}
export namespace UpdateDataRequest {
    export type DataTypeEnum = 'ADDRESS' | 'INSTITUTE' | 'OBJECT';
    export const DataTypeEnum = {
        Address: 'ADDRESS' as DataTypeEnum,
        Institute: 'INSTITUTE' as DataTypeEnum,
        Object: 'OBJECT' as DataTypeEnum
    };
}


